export interface MenuItem {
  id: string;
  title: string;
  description: string;
  icon: string;
  link: string | null;
  isAdminOnly: boolean;
  isDisabled: boolean;
  category: string;
  subCategory?: string;
  subCategoryTitle?: string;
  roles: string[];
}
export const FORM_FIELD_TYPES = [
  { name: 'Input Text', code: 'free-text' },
  { name: 'Single Choice', code: 'single-choose' },
  { name: 'Single Choice with Keys', code: 'single-choose-keys' },
  { name: 'Input Text With Options', code: 'text-single-choice' },
  { name: 'Multiple Choice', code: 'multiple-choose' },
  { name: 'Date', code: 'date' },
  { name: 'Yes / No', code: 'yesno' },
  { name: 'File Upload', code: 'file-upload' },
  { name: 'Table', code: 'table' },
  { name: 'Related Submission Choice', code: 'related-submission-choice' },
  { name: 'Form Resource', code: 'form-resource' },
];

export const FIELD_TYPES = [
  { name: 'Yes / No', code: 'yesno' },
  { name: 'True / False', code: 'boolean' },
  { name: 'Single Choice', code: 'single-choose' },
  { name: 'Single Image Choice', code: 'single-image' },
  { name: 'Multiple Choice', code: 'multiple-choose' },
  { name: 'Satisfactory Scale', code: 'satisfactory-scale' },
  { name: 'Ranking', code: 'ranking' },
  { name: 'Free Text', code: 'free-text' },
];

export const MULTIPLE_SELECTION_FIELDS = [
  'single-choose',
  'multiple-choose',
  'ranking',
  'single-image',
];

export const FORM_MULTIPLE_SELECTION_FIELDS = [
  'single-choose',
  'single-choose-keys',
  'multiple-choose',
  'text-single-choice',
];

export const FORM_TEXT_INPUT_TYPES = [
  { name: 'Alphanumeric', code: 'alphanumeric' },
  { name: 'Numeric', code: 'numeric' },
  { name: 'Email', code: 'email' },
  { name: 'Url', code: 'url' },
  { name: 'Phone-number', code: 'phone-number' },
  { name: 'Multiple Lines', code: 'multi-lines' },
];

export const EMAIL_MAX_LENGTH = 254;

export const URL_MAX_LENGTH = 2048;

export interface Tag {
  uuid: string;
  value: string;
  color: string;
  loading?: boolean;
}
